import * as React from 'react';
import scrollToComponent from 'react-scroll-to-component';

import DiagramModel from 'src/model/diagram.model';
import ProductModel from 'src/model/product.model';

import DiagramsDisplay from 'src/components/DiagramsDisplay';
import PartsCatalog from 'src/components/PartsCatalog';

import { isMobile } from 'src/utils/responsiveHelpers';

import './ModelView.scss';

export default class ModelView extends React.Component<any, any> {
  private catalogRef: any;

  constructor(props: any) {
    super(props);

    this.state = {
      productsToShow: [],
      isMobile: isMobile()
    };

    this.catalogRef = null;
  }

  private renderHeader = (t: any) => {
    const { activeDiagram } = this.props;
    if (this.props.getModelIsPending) {
      return <p>Loading...</p>;
    } else {
      if (activeDiagram !== -1) {
        const diagram = this.getActiveDiagram();
        return (
          <p className="header-title">
            {`${
              diagram.diagramName ? diagram.diagramName : diagram.diagramId
            } ${t('common.from')} ${t('common.model')} ${
              this.props.modelNumber
            } `}
          </p>
        );
      } else {
        return (
          <p className="header-title">{`${t('model.commonParts')} ${t(
            'common.model'
          )} ${this.props.modelNumber}`}</p>
        );
      }
    }
  };

  private getActiveDiagram = (): DiagramModel | null => {
    if (this.props.activeDiagram !== -1) {
      const activeDiagram = this.props.diagrams.findIndex(
        (diagram: DiagramModel) =>
          diagram.diagramId === this.props.activeDiagram
      );
      return this.props.diagrams[activeDiagram];
    } else {
      return null;
    }
  };

  private orderProducts(products: ProductModel[]): ProductModel[] {
    let top: ProductModel[] = [];
    let bottom: ProductModel[] = [];
    if (this.props.activeDiagram === -1) {
      products.forEach(product => {
        if (product.available) {
          top.push(product);
        } else {
          bottom.push(product);
        }
      });
      products = top.concat(bottom);
    }
    top = [];
    bottom = [];

    products.forEach(product => {
      if (
        product.description?.toLowerCase().includes('literature') ||
        product.description?.toLowerCase().includes('manual') ||
        product.description?.toLowerCase().includes('use and care') ||
        product.description?.toLowerCase().includes('attention installer') ||
        product.description?.toLowerCase().includes('installation instructions') ||
        product.description?.toLowerCase().includes('instruction install') ||
        product.description?.toLowerCase().includes('tech sheet') ||
        product.description?.toLowerCase().includes('guide, energy') ||
        product.description?.toLowerCase().includes('energy guide')
      ) {
        bottom.push(product);
      } else {
        top.push(product);
      }
    });

    return top.concat(bottom);
  }

  private selectDataSource() {
    let products = [];
    if (this.props.textFilter === '') {
      if (this.props.activeDiagram !== -1) {
        products = this.getActiveDiagram().products;
      } else {
        products = this.props.allProducts.slice(0, 15);
      }
    } else {
      this.props.setActiveDiagram(-1);
      products = this.searchByKeyword(this.props.textFilter);
    }

    return this.orderProducts(products);
  }

  private setCommonParts() {
    const allProducts: ProductModel[] = [];
    this.props.commonParts.map((item: DiagramModel) => {
      allProducts.push.apply(allProducts, item.products);
    });
    allProducts.sort((a, b) => {
      if (a.score < b.score) {
        return -1;
      } else if (a.score > b.score) {
        return 1;
      } else {
        return 0;
      }
    });
    return allProducts;
  }

  private goToDiagram = (diagramId: number) => {
    this.props.setActiveDiagram(diagramId);
    this.props.setTextFilter('');
  };

  private getParts = () => {
    this.props.getModelData(
      this.props.match.params.modelId,
      this.props.activeAccount,
      this.props.match.params.manufacturer
    );
  };

  private searchByKeyword = (keyword: string) => {
    const allProducts: ProductModel[] = [];
    const keywordLower = keyword.toLowerCase();
    this.props.allProducts.filter((product: ProductModel) => {
      if (
        product.replacedPart
          ? product.replacedPart.toLowerCase().includes(keywordLower) ||
            product.description?.toLowerCase().includes(keywordLower) ||
            product.productNumber.toLowerCase().includes(keywordLower) ||
            product.diagramReferenceNumber.toLowerCase().includes(keywordLower)
          : product.description?.toLowerCase().includes(keywordLower) ||
            product.productNumber.toLowerCase().includes(keywordLower) ||
            product.diagramReferenceNumber.toLowerCase().includes(keywordLower)
      ) {
        allProducts.push(product);
      }
    });
    return allProducts;
  };

  private scrollToPartsCatalog = () => {
    const offsetValue = this.state.isMobile ? -48 : -80;
    const scrollConfig = {
      offset: offsetValue,
      align: 'top',
      duration: 500
    };
    scrollToComponent(this.catalogRef, scrollConfig);
  };

  private searchDiagramByKeyword = (keyword: string) => {
    const allProducts: ProductModel[] = [];
    const keywordLower = keyword.toLowerCase();
    this.getActiveDiagram().products.filter((product: ProductModel) => {
      if (
        product.replacedPart
          ? product.replacedPart.toLowerCase().includes(keywordLower) ||
            product.description?.toLowerCase().includes(keywordLower) ||
            product.productNumber.toLowerCase().includes(keywordLower) ||
            product.diagramReferenceNumber.toLowerCase().includes(keywordLower)
          : product.description?.toLowerCase().includes(keywordLower) ||
            product.productNumber.toLowerCase().includes(keywordLower) ||
            product.diagramReferenceNumber.toLowerCase().includes(keywordLower)
      ) {
        allProducts.push(product);
      }
    });
    return allProducts;
  };

  private handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  private closeActiveDiagram = () => {
    this.props.setActiveDiagram(-1);
    this.props.sendModelDiagramProductImpression(-1);
  };

  public componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    this.props.setActiveDiagram(-1);
    this.props.setActivePart(null);
    this.getParts();

    // gets cart and user deliver method for part details cart
    this.props.getCartBasicInfo();
    this.props.getUserDetails();
  }

  public componentDidUpdate(prevProps: any) {
    if (
      prevProps.match.params.modelId !== this.props.match.params.modelId ||
      (prevProps.match.params.modelId === this.props.match.params.modelId &&
        prevProps.match.params.manufacturer !==
          this.props.match.params.manufacturer)
    ) {
      this.props.setActiveDiagram(-1);
      this.props.setActivePart(null);
      this.getParts();
    }
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public render() {
    const { props } = this;
    const { t } = props;
    const diagram = this.getActiveDiagram();
    return (
      <section id="rp-model-view roboto">
        <div className="rp-model-view--header">
          <DiagramsDisplay
            modelNumber={props.modelNumber}
            diagrams={props.diagrams}
            scrollToPartsCatalog={this.scrollToPartsCatalog}
            getModelIsPending={props.getModelIsPending}
            searchMethod={props.setTextFilter}
            searchValue={props.textFilter}
            setActiveDiagram={props.setActiveDiagram}
            activeDiagram={this.getActiveDiagram()}
            activePart={this.props.activePart}
            setActivePart={this.props.setActivePart}
            sendModelDiagramProductImpression={
              this.props.sendModelDiagramProductImpression
            }
          />
        </div>
        <div className="rp-model-view--sections" />
        <div className="rp-model-view--common-parts">
          <div className="header">{this.renderHeader(t)}</div>
          <div className="catalog" ref={ref => (this.catalogRef = ref)}>
            <div className="rp-return-container">
              {props.activeDiagram === -1 ? (
                <React.Fragment />
              ) : (
                <div
                  className="rp-parts-return"
                  onClick={this.closeActiveDiagram}
                >
                  Go back to common parts
                </div>
              )}
            </div>
            <PartsCatalog
              isLoggedIn={this.props.isLoggedIn}
              onlyMsrp={this.props.onlyMSRP}
              parts={this.selectDataSource()}
              commonParts={this.setCommonParts()}
              updateProductMethod={this.props.updateDiagramProduct}
              updateProductsMethod={this.props.updateDiagramProducts}
              updateCommonPartsMethod={this.props.updateCommonParts}
              emptyMessage={t('common.noPartsToShow')}
              diagrams={props.diagrams}
              loading={props.getModelIsPending}
              useActiveDiagram={props.activeDiagram === -1 ? false : true}
              activeDiagram={this.getActiveDiagram()}
              goToDiagram={this.goToDiagram}
              activePart={this.props.activePart}
              setActivePart={this.props.setActivePart}
              handleToggleFavorite={this.props.toggleFavoritePart}
              featuredProducts={this.props.featuredProducts}
              updateFeaturedProduct={this.props.updateFeaturedProduct}
              textFilter={this.props.textFilter}
              modelDiagramProductClick={this.props.modelDiagramProductClick}
            />
          </div>
        </div>
      </section>
    );
  }
}
